module.exports = __webpack_public_path__ + "static/media/bannerBonif.08fffb2c.png";